import { IntlShape } from "react-intl";

export const getFormattedTime = (
  time: { h: number; m: number },
  intl: IntlShape,
): string => {
  const formatter = new Intl.DateTimeFormat(intl.locale, {
    hour: "numeric",
    minute: "numeric",
  });
  const date = new Date();
  date.setHours(time.h, time.m);
  return formatter.format(date);
};
